import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import { FaArrowLeft } from "react-icons/fa";
import "./styles/Wall.css";
import "./styles/Comments.css";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import WallLeft from "../components/WallLeft";
import WallRight from "../components/WallRight";
import CommentCenter from "../components/CommentCenter";
import * as actions from "../redux/actions/adCommentActions";

class Comment extends Component {
  componentDidMount() {
    this.fetchCommentList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.comment_id !== this.props.match.params.comment_id) {
      this.fetchCommentList();
    }
  }

  fetchCommentList = async () => {
    const comment_id = this.props.match.params.comment_id;
    const params = {
      comment_id,
      id: this.props.user_id,
      lang: I18n.t("locale"),
    };

    try {
      await Promise.all([
        this.props.LoadCommentItem(this.props.token, params),
        this.props.LoadComment(this.props.token, params),
      ]);

      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <div className="wall-page">
        <div className="wall-page-inner">
          <div className="row">
            <aside className="col-lg-3 d-none d-lg-block wall-page-side">
              <WallLeft />
            </aside>
            <main className="col-lg-6 wall-page-main">
              <div className="comment-thread-page">
                <Link to="/wall" className="comment-thread-back">
                  <FaArrowLeft />
                  <Translate value="comment_thread_back" />
                </Link>
                <CommentCenter
                  commentId={this.props.match.params.comment_id}
                  loadingReplies={this.props.loading}
                />
              </div>
            </main>
            <aside className="col-lg-3 d-none d-lg-block wall-page-side">
              <WallRight />
            </aside>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    error: reducer.adComment.error,
    commentList: reducer.adComment.list,
    loading: reducer.adComment.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadComment: (token, params) =>
    dispatch(actions.loadList({ token, params })),
  LoadCommentItem: (token, params) =>
    dispatch(actions.loadCommentItem({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comment);
